import React, { Component } from 'react';

import { faunaAPI } from "../api/fauna-api";
import { withStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import {
  Drawer,
  CssBaseline,
  AppBar,
  Toolbar,
  List,
  Typography,
  ListItem,
  Collapse,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';

import AllInboxIcon from '@material-ui/icons/AllInbox';
import BarChartIcon from '@material-ui/icons/BarChart';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Logout from './Logout.js'

import logo from '../images/logo.svg'

import NavigationItem from './NavigationItem';

const drawerWidth = 240;

const styles = (theme) => ({
  root: {
    display: 'flex',
    [theme.breakpoints.down(1360)]: {
      zoom: 0.85,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

});

class Layout extends Component {

  constructor(props) {
    super(props);
    this.toggleReportsMenu = this.toggleReportsMenu.bind(this);
    this.state = {
      reportsMenuExpanded: !!props.history.location.pathname.match(/\/reports/) 
    }
  }

  toggleReportsMenu() {
    this.setState({reportsMenuExpanded: !this.state.reportsMenuExpanded});
  }

  render () {

    const { classes, user } = this.props;
    const { reportsMenuExpanded } = this.state;

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            <Typography variant="h6" style={{flexGrow: '1'}}>
              <img
                src={logo}
                style={{
                  width: '46px',
                  objectFit: 'cover',
                  height: '19px',
                  display: 'inline-block',
                  margin: '6px 10px 0px 0px',
                  objectPosition: 'top',
                  verticalAlign: 'top',
                }}
              />
              Purchase Manager
            </Typography>
            <Typography>
              {user.email}
            </Typography>
            <Logout style={{position: 'absolute', right: '0'}}></Logout>
          </Toolbar>
        </AppBar>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Toolbar />
          <div className={classes.drawerContainer}>
            <List>
              <NavigationItem to='/purchase-orders' icon={<AllInboxIcon/>} text='Purchase orders' />
              <NavigationItem to='/cost-centres' icon={<LocalOfferIcon/>} text='Cost centres' />
              { user.type === 'admin' && (<>
                <ListItem button onClick={this.toggleReportsMenu}>
                  <ListItemIcon>
                    <BarChartIcon />
                  </ListItemIcon>
                  <ListItemText primary="Reports" />
                  {reportsMenuExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItem>
                <Collapse in={reportsMenuExpanded} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem button component={NavLink} activeClassName="Mui-selected" to='/reports/overview' style={{paddingLeft: '70px'}}>
                      <ListItemText primary="Spending overview" />
                    </ListItem>
                    <ListItem button component={NavLink} activeClassName="Mui-selected" to='/reports/cost-explorer' style={{paddingLeft: '70px'}}>
                      <ListItemText primary="Cost explorer" />
                    </ListItem>
                  </List>
                </Collapse>
              </>)}
            </List>
          </div>
        </Drawer>
        <main className={classes.content}>
          <Toolbar />
          {this.props.children}
        </main>
      </div>
    )
  }
}

export default withStyles(styles)(withRouter(Layout));